import * as React from 'react';
import sortBy from 'sort-by';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { ColumnDef } from '@tanstack/react-table';
import { TanstackTable } from 'Shared/Components/Mui/TanstackTable/index';
import RegisterStructure from 'Shared/Constant/AssociateTargetModal/RecordStructure';
import { IHomeTargetsSupplier } from 'Module/HomeUser/Interface/HomeTargetsSupplier';
import { IFieldStructure } from 'Shared/Interfaces/ObjectSalesforce';
import { Grid, LinearProgress, Typography } from '@mui/material';
import { IAssociateDetailPage } from 'Module/AssociateDetail/Interface';
import ModalQuestionYesNoPage from 'Shared/Components/ModalQuestionYesNo/index';
import { IModalQuestionYesNoPage } from 'Shared/Components/ModalQuestionYesNo/Interface';
import TypeAnswerConstant from 'Shared/Constant/TypeAnswer/index';

import { Form } from '@unform/web';
function PaperComponent(props: PaperProps) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

export default function AssociateTargetModalPage(props: IAssociateDetailPage) {

  const formDefault = React.useRef<any>(null);
  const [open] = React.useState(true);

  const [columns, setColumns] = React.useState<ColumnDef<object, any>[]>([]);
  const toggleSetColumns = (values: ColumnDef<object, any>[]) => {
    setColumns(values);
  }

  const [oldData, setOldData] = React.useState<IHomeTargetsSupplier>({});
  const [newData, setNewData] = React.useState<IHomeTargetsSupplier>({});
  const toggleEditItemModal = async (oldData: any, newData: any) => {
    if (oldData.metaFaturamento !== newData.metaFaturamento) {
      let _preparar = newData.metaFaturamento.replace('R$', '').replace(/\./g, '').replace(/,/g, '.').trim();
      let _numero = Number(_preparar * 10).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      newData.metaFaturamento = _numero
    }

    setOldData(oldData);
    setNewData(newData);

    if (props.toggleShowModalQuestionYesNo) {
      props.toggleShowModalQuestionYesNo(true);
    }
  }

  const toggleAnswerModal = (key: string) => {
    switch (key) {
      case TypeAnswerConstant.YES:
      case TypeAnswerConstant.OK:
        const dataUpdate: IHomeTargetsSupplier[] = data.map((el: IHomeTargetsSupplier) => el);
        let index = -1;
        if (dataUpdate.find((elOld: IHomeTargetsSupplier) => elOld.id === oldData.id)) {
          const _itemAux = dataUpdate.find((elOld: IHomeTargetsSupplier) => elOld.id === oldData.id) || {};
          index = dataUpdate.indexOf(_itemAux);
        }
        if (index > -1) {
          dataUpdate[index] = newData;
        }
        setData(dataUpdate);
        if (props.toggleSetAssociateTarget) {
          const _id: string = newData.id ? newData.id : oldData.id ? oldData.id : '';
          const _itemNew: IHomeTargetsSupplier = {
            codigo: newData.codigo,
            nome: newData.nome,
            codigoFornec: newData.codigoFornec,
            metaMix: newData.metaMix ? Number(newData.metaMix.replace(/\./g, '').replace(',', '.')).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).padStart(4, '0') : '0000',
            metaFaturamento: newData.metaFaturamento ? newData.metaFaturamento.replace(/\./g, '').replace(',', '.') : '0',
            userupdate: props.profile.userid,
            ipupdate: props.publicIPInfo,
            deviceupdate: 'Portal',
          }
          props.toggleSetAssociateTarget(_itemNew, _id)
        }

        break;
      default:
        break;
    }
  }

  const [data, setData] = React.useState<object[]>([]);
  const toggleSetData = (values: [IHomeTargetsSupplier?]) => {
    const _array: object[] = values.map(reg => reg || {});
    setData(_array);
  }

  const handleSubmit = (data: any) => {

  };

  const getFieldsStructure = React.useCallback((list: IFieldStructure[]) => {
    const _array: ColumnDef<object, any>[] = [];
    if (list && list.length > 0) {
      for (let regField of list.sort(sortBy('orderFormMain'))) {
        let _column: ColumnDef<object, any> | null = null;
        if (regField.viewFormMain && regField.nameField) {
          switch (regField.type) {
            case 'checkbox':
              _column = {
                id: regField.nameField,
                accessorKey: regField.nameField,
                header: regField.label,
                cell: ({ row }) => {
                  const rowdata = row.original as any;
                  if (regField.nameField === 'active') {
                    return (<input type="checkbox" checked={rowdata.active} readOnly />)
                  }
                  else if (regField.nameField === 'isMeta') {
                    return (<input type="checkbox" checked={rowdata.isMeta} readOnly />)
                  }
                  return (<input type="checkbox" checked={Boolean(row.getValue(regField.nameField!))} readOnly />);
                },
              }
              break;
            case 'currency':
              _column = {
                id: regField.nameField,
                accessorKey: regField.nameField,
                header: regField.label,
                meta: {
                  align: 'right',
                },
              };
              break;
            case 'number':
              _column = {
                id: regField.nameField,
                accessorKey: regField.nameField,
                header: regField.label,
                meta: {
                  align: 'right',
                },
              };
              break;
            default:
              _column = {
                id: regField.nameField,
                accessorKey: regField.nameField,
                header: regField.label,
              };
              break;
          }
          if (!_column || regField.hiddenFormMain) {
            continue;
          }
          if (regField.width || regField.cellStyle) {
            _column.meta = {
              ...(typeof _column.meta === 'object' ? _column.meta : {}),
              cellSx: regField.cellStyle,
              headerSx: regField.width ? { width: regField.width } : undefined,
            };
          }

          switch (regField.nameField) {
            case 'qtCxFaturada':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'vlrVenda':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'valorBase':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              // _column.render = (rowData: any) => parseFloat(rowData.valorBase.replace(/\./g, '').replace(/,/g, '.')).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', currencyDisplay: 'narrowSymbol' }).replace('R$', ''); // Formata o número no formato pt-br sem moeda
              break;
            case 'qtdeBase':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'metaMix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'mix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'percentMix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'metaFaturamento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'faturamento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'percentFaturmento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'caixas':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'qtUnitCx':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'vlrUnitario':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            default:
              break;
          }

          _array.push(_column);
        }
      }
    }
    toggleSetColumns(_array);

  }, [])

  const handleClose = () => {
    if (props.toggleShowAssociateTargetModal) {
      props.toggleShowAssociateTargetModal(false);
    }
  };

  React.useEffect(() => {
    getFieldsStructure(RegisterStructure);
    toggleSetData(props?.listModalTargetsSupplier || []);
  }, [props.listModalTargetsSupplier, props.dateUpdateInfo, getFieldsStructure])

  const handlerModalQuestion: IModalQuestionYesNoPage = {
    ...props,
    titlePage: 'Confirmação',
    question: 'Deseja alterar o registro?',
    toggleAnswer: toggleAnswerModal,
    toggleShowModalQuestion: props.toggleShowModalQuestionYesNo
  }

  return (
    <div>
      <Form
        ref={formDefault}
        id="myFormDefault"
        name="myFormDefault"
        onSubmit={handleSubmit}
      >
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            <Grid container spacing={1}>
              <Grid item xs={6} sm={8} md={9} lg={10} xl={10}>
                <Typography component={'div'} align='left'>
                  <span className='AssociatesReportModalTitle'>{props?.titleModalTargetsSupplier || 'Metas'}</span>
                  {props.showLoadingUpdateTable && (
                    <Typography component="span" sx={{ display: 'inline-flex', width: 120 }}>
                      <LinearProgress />
                    </Typography>
                  )}
                </Typography>

              </Grid>
              <Grid item xs={6} sm={4} md={3} lg={2} xl={2}>
                <Typography component={'div'} align='right'>
                  <Button
                    variant="contained"
                    color="success"
                    className="ButtonDanger"
                    type="button"
                    autoFocus
                    onClick={handleClose}
                  >
                    <span>Fechar</span>
                  </Button>
                </Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <DialogContentText component={'div'}>
              <TanstackTable
                data={data}
                columns={columns}
                title="Metas fornecedores"
                isLoading={props.showLoadingThisPage}
                enableGlobalFilter
                stickyHeader
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
          </DialogActions>
        </Dialog>
      </Form>
      {props.showModalQuestionYesNo &&
        <ModalQuestionYesNoPage {...handlerModalQuestion} />
      }
    </div>
  );
}
